document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".sp-product-info-tabs__tabs button");
  const panes = document.querySelectorAll(".sp-product-info-tab__pane");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const tabContent = tab.getAttribute("data-tab");
      const activePane = document.querySelector(
        `.sp-product-info-tab__pane[data-tab="${tabContent}"]`
      );

      if (tab.classList.contains("active")) {
        tab.classList.remove("active");
        if (activePane) {
          activePane.classList.remove("active");
        }
      } else {
        tabs.forEach((tab) => tab.classList.remove("active"));
        panes.forEach((pane) => pane.classList.remove("active"));

        tab.classList.add("active");
        if (activePane) {
          activePane.classList.add("active");
        }
      }
    });
  });
});
